import { APIClient } from "../helpers/api_helper";

const api = new APIClient();

/**
 * Fetch notification summary counts
 * @returns {Promise} API response
 */
export const getNotificationSummary = async () => {
  try {
    const response = await api.get("/notifications/summary");
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Mark notifications as read.
 * If type is provided, it marks notifications of that type as read.
 * If type is not provided, it marks all notifications as read.
 * @param {string} [type] - Optional notification type (DEPOSIT | WITHDRAWAL | NEW_ACCOUNT | KYC)
 * @returns {Promise} API response
 */
export const readAllNotifications = async (type) => {
  try {
    const url = type ? `/notifications/readAll?type=${type}` : "/notifications/readAll";
    const response = await api.put(url, {});
    return response;
  } catch (error) {
    throw error;
  }
};
